import { render, staticRenderFns } from "./ColorCardManage.vue?vue&type=template&id=1cbb7da0&scoped=true&"
import script from "./ColorCardManage.vue?vue&type=script&lang=js&"
export * from "./ColorCardManage.vue?vue&type=script&lang=js&"
import style0 from "./ColorCardManage.vue?vue&type=style&index=0&id=1cbb7da0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbb7da0",
  null
  
)

component.options.__file = "ColorCardManage.vue"
export default component.exports